export default __webpack_public_path__ + "static/media/818.47540604.png";